import Draggabilly from 'draggabilly';
import Packery     from 'packery';
import metaContent from '../fn/metaContent';

Packery.prototype.getShiftPositions = function() {
  const width = this.packer.width;

  return this.items.map(({ element, rect }) => ({
    attr: element.id,
    x: rect.x / width,
  }));
};

Packery.prototype.initShiftLayout = function(positions) {
  if (!positions) { this.layout(); return; }

  if (typeof positions == 'string') {
    try {
      positions = JSON.parse(positions);
    } catch(error) {
      console.error(`JSON parse error: ${error}`);
      this.layout();
      return;
    }
  }

  this._resetLayout();

  positions.forEach(function({attr, x}) {
    const selector = `[id="${attr}"]`;
    const itemElem = this.element.querySelector(selector);
    if (!itemElem) { return; }
    const item = this.getItem(itemElem);
    item.rect.x = x * this.packer.width;
    return item;
  }, this);

  this.shiftLayout();
};

const initDraggie = (subnode, pckry) => {
  const draggie = new Draggabilly(subnode, { handle: '.masun-handle' });
  pckry.bindDraggabillyEvents(draggie);
}

const initNode = (node) => {
  const pckry = new Packery(node, {
    columnWidth: 50,
    initLayout: false,
    itemSelector: '.masun-item',
    percentPosition: true,
  });

  const userID = metaContent('userID');
  const localKey = `masun_positions__user_${userID}__width_${node.clientWidth}__id_${node.id}`;
  const initPositions = localStorage.getItem(localKey);
  pckry.initShiftLayout(initPositions);

  const subnodes = node.querySelectorAll('.masun-item');
  Array.from(subnodes).forEach(subnode => initDraggie(subnode, pckry));

  pckry.on('dragItemPositioned', () => {
    const positions = pckry.getShiftPositions();
    localStorage.setItem(localKey, JSON.stringify(positions));
  });
};

const init = () => {
  const nodes = document.querySelectorAll('.masun-flex');
  Array.from(nodes).forEach(node => initNode(node));
};

const start = () => {
  document.addEventListener('page:load', init);
};

export default { start };
